import {
  COMMONCONFIGURADETAILS_SUCCESS,
  COMMONCONFIGURADETAILS_FAILED,
  RESET_COMMONCONFIGURADETAILS,
  LOADING_COMMONCONFIGURADETAILS,
  NETWORK_ERROR_COMMONCONFIGURADETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetCommonCfgDetails = () => {
  return { type: RESET_COMMONCONFIGURADETAILS };
};

const commonCfgDetailsReqList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_COMMONCONFIGURADETAILS });
  await partnerServices
    .post("getCommonConfigurationDetails", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getCommonCfgsuccess(res.data));
          break;
        default:
          dispatch(getCommonCfgFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_COMMONCONFIGURADETAILS, payload: err });
    });
};
function getCommonCfgsuccess(data) {
  return {
    type: COMMONCONFIGURADETAILS_SUCCESS,
    payload: data,
  };
}
function getCommonCfgFailed(data) {
  return {
    type: COMMONCONFIGURADETAILS_FAILED,
    payload: data,
  };
}

export { resetCommonCfgDetails, commonCfgDetailsReqList };
